<template>
  <div class=" is-fullwidth">
    <div class="level">
      <div class="level-left">
        
      </div> 
      <div class="level-right">
          <div class="columns" >
              
             <div class=" col">
                &nbsp;<input type="date" class="input" v-model="start_date" />
                
              </div>
              <div class=" col" >
                &nbsp;<input type="date" class="input" v-model="end_date" />
                
              </div>

              
        </div>
      </div>
    </div>

    <h2 class="title is-4">Internal Orders</h2>

        <div class="notification is-info" v-if="loadingInternalOrders === true">
            <p>Loading internal orders ...</p>
        </div>

        <div class="notification is-warning" v-if="loadingInternalOrders === false && internal_orders.length == 0">
            <p>There are no orders to display</p>
        </div>
    
    <table class="table is-hoverable is-fullwidth is-size-7" id="internalorders" v-if="loadingInternalOrders === false && internal_orders.length > 0">
    	<thead>
    		<tr>
        <th>Date</th>
   	 		<th>Product</th>
          <th>Description</th>
          <th>Qty</th>
          <th>Unit Cost</th>
          <th>Total</th>
          
        </tr>
    	</thead>
    	<tbody>
		    
            
            <tr v-for="row in internal_orders" v-bind:key="row.id">
         
                <td >{{row.date}}</td>
          <td >{{row.internal_product_name}}</td>
          <td>{{ row.description }}</td>
          <td>{{row.quantity}}</td>
          <td>{{ formatPrice(row.unit_price) }}</td>
          <td>{{ formatPrice(row.unit_price * row.quantity) }}</td>
          
          
          
              
			</tr>
    	</tbody>
    </table>

    <h2 class="title is-4">Print/Cut in Strabane and Makeup in Dublin</h2>

    <div class="notification is-info" v-if="loadingMakeupDublinOrders === true">
            <p>Loading  orders ...</p>
        </div>

        <div class="notification is-warning" v-if="loadingMakeupDublinOrders === false && makeup_dublin_orders.length == 0">
            <p>There are no orders to display</p>
        </div>

    <table class="table is-hoverable is-fullwidth  is-size-7" id="makeuporders" v-if="loadingMakeupDublinOrders === false && makeup_dublin_orders.length > 0">
    	<thead>
        <tr>
    		<th>Date Assigned</th>
        <th>PO Number</th>
   	 		<th>Client</th>
            <th>Location</th>
            <th>Garment</th>
            <th>Design Name</th>
            <th>Emb.</th>
            <th>Juniors</th>
            <th>Unit Cost</th>
            <th>Total</th>
            <th>Kids</th>
            <th>Unit Cost</th>
            <th>Total</th>
            <th>Adults</th>
            <th>Cost</th>
            <th>Total</th>
            <th>Grand Total</th>
          </tr>
    	</thead>
    	<tbody>
		    
            
            <tr v-for="row in makeup_dublin_orders" v-bind:key="row.orderID" :class="{'is-selected' : row.clientLocationID == 1}">
                <td >{{row.date}}</td>
                <td >{{row.ponumber}}</td>
          <td >{{row.clientname}}</td>
          <td>{{ displayClientLocationName(row.clientLocationID) }}</td>
          <td>{{ row.garmentname }}</td>
          <td>{{ row.designname }}</td>
          <td><span v-if="row.requires_embroidery == 1">Yes</span></td>
          <td>{{ row.junior_qty }}</td>
          <td>{{ row.pricing_junior }}</td>
          <td>{{ formatPrice(row.junior_qty * row.pricing_junior) }}</td>
          <td>{{ row.kids_qty }}</td>
          <td>{{ row.pricing_kids }}</td>
          <td>{{ formatPrice(row.kids_qty * row.pricing_kids) }}</td>
          <td>{{ row.adults_qty }}</td>
          <td>{{ row.pricing_adults }}</td>
          <td>{{ formatPrice(row.adults_qty * row.pricing_adults) }}</td>
          <td>{{ formatTotal( formatPrice(row.junior_qty * row.pricing_junior) + formatPrice(row.kids_qty * row.pricing_kids) + formatPrice(row.adults_qty * row.pricing_adults) ) }}</td>
          
              
			</tr>
    	</tbody>
    </table>

    <h2 class="title is-4">Print/Cut in Strabane and Makeup in Strabane/Derry</h2>

    <div class="notification is-info" v-if="loadingMakeupStrabaneOrders === true">
            <p>Loading  orders ...</p>
        </div>

        <div class="notification is-warning" v-if="loadingMakeupStrabaneOrders === false && makeup_strabane_orders.length == 0">
            <p>There are no orders to display</p>
        </div>

    <table class="table is-hoverable is-fullwidth  is-size-7" id="madeupinstrabane" v-if="loadingMakeupStrabaneOrders === false && makeup_strabane_orders.length > 0">
    	<thead>
        <tr>
    		<th>Date Assigned</th>
        <th>Makeup Location</th>
        <th>PO Number</th>
   	 		<th>Client</th>
            <th>Location</th>
            <th>Garment</th>
            <th>Design Name</th>
            <th>Emb.</th>
            <th>Juniors</th>
            <th>Unit Cost</th>
            <th>Total</th>
            <th>Kids</th>
            <th>Unit Cost</th>
            <th>Total</th>
            <th>Adults</th>
            <th>Cost</th>
            <th>Total</th>
            <th>Grand Total</th>
          </tr>
    	</thead>
    	<tbody>
		    
            
            <tr v-for="row in makeup_strabane_orders" v-bind:key="row.orderID" :class="{'is-selected' : row.clientLocationID == 1}">
                <td >{{row.date}}</td>
                <td>{{  row.makeup_location_name }}</td>
                <td >{{row.ponumber}}</td>
          <td >{{row.clientname}}</td>
          <td>{{ displayClientLocationName(row.clientLocationID) }}</td>
          <td>{{ row.garmentname }}</td>
          <td>{{ row.designname }}</td>
          <td><span v-if="row.requires_embroidery == 1">Yes</span></td>
          <td>{{ row.junior_qty }}</td>
          <td>{{ row.pricing_junior }}</td>
          <td>{{ formatPrice(row.junior_qty * row.pricing_junior) }}</td>
          <td>{{ row.kids_qty }}</td>
          <td>{{ row.pricing_kids }}</td>
          <td>{{ formatPrice(row.kids_qty * row.pricing_kids) }}</td>
          <td>{{ row.adults_qty }}</td>
          <td>{{ row.pricing_adults }}</td>
          <td>{{ formatPrice(row.adults_qty * row.pricing_adults) }}</td>
          <td>{{ formatTotal( formatPrice(row.junior_qty * row.pricing_junior) + formatPrice(row.kids_qty * row.pricing_kids) + formatPrice(row.adults_qty * row.pricing_adults) ) }}</td>
          
              
              
			</tr>
    	</tbody>
    </table>

    <br />
    <button class=" button is-success" @click="exportResultsXLS()">Export to Excel</button>
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  components: {
   	
  },
     mixins: [OrderMixin],
  data() {
    return {
       errors: [],
       internal_orders: [],
       makeup_dublin_orders: [],
       makeup_strabane_orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loadingInternalOrders: true,
      loadingMakeupDublinOrders: true,
      loadingMakeupStrabaneOrders: true,
      locations: [],
      makeuplocations: [],
      ASP_URL : process.env.VUE_APP_ASP_URL,
      start_date: '',
        end_date: '',
        accessToken:''
    }
  },
   methods: {
      async getInternalOrders() {
            this.internal_orders = [];
            this.loadingInternalOrders=true
            OrderService.getInternalOrders(this.accessToken, this.start_date, this.end_date)
            .then(
            (internal_orders => {
                this.$set(this, "internal_orders", internal_orders);
                this.loadingInternalOrders=false
            }).bind(this)
            );
        
      },

      async getMakeupDublinOrders() {
        this.loadingMakeupDublinOrders=true
        OrderService.getMakeupDublinOrders(this.accessToken, this.start_date, this.end_date)
        .then(
          (makeup_dublin_orders => {
            this.$set(this, "makeup_dublin_orders", makeup_dublin_orders);
            this.loadingMakeupDublinOrders=false
          }).bind(this)
        );
      },
      async getMakeupStrabaneOrders() {
        this.loadingMakeupStrabaneOrders=true
        OrderService.getMakeupStrabaneOrders(this.accessToken, this.start_date, this.end_date)
        .then(
          (makeup_strabane_orders => {
            this.$set(this, "makeup_strabane_orders", makeup_strabane_orders);
            this.loadingMakeupStrabaneOrders=false
          }).bind(this)
        );
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2)// .replace('.', ',')
        return parseFloat(val) //.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    formatTotal(value) {
        let val = (value/1).toFixed(2)// .replace('.', ',')
        return parseFloat(val) //.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    exportResultsXLS() {
      var wb = XLSX.utils.book_new();
      
      if(this.internal_orders.length > 0)
      {
      wb.SheetNames.push("Internal Orders");
      var ws1 = XLSX.utils.table_to_sheet(document.getElementById('internalorders'));
      wb.Sheets["Internal Orders"] = ws1;
      }

      if(this.makeup_dublin_orders.length > 0)
      {
      wb.SheetNames.push("Madeup in Dublin");
      var ws2 = XLSX.utils.table_to_sheet(document.getElementById('makeuporders'));
      wb.Sheets["Madeup in Dublin"] = ws2;
      }

      if(this.makeup_strabane_orders.length > 0)
      {
      wb.SheetNames.push("Madeup in Strabane");
      var ws3 = XLSX.utils.table_to_sheet(document.getElementById('madeupinstrabane'));
      wb.Sheets["Madeup in Strabane"] = ws3;
      }


      XLSX.writeFile(wb, 'Dublin Finance Report.xlsx')

    },
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 31);
            return d.toISOString().slice(0,10);
             
        },
    
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) {
            if(  u.completed == 1) // u.artwork_new == 0 && u.artwork_repeat == 0 &&
            {
              return 1
            }
          })

          return filteredOrders
       
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getInternalOrders();
           this.getMakeupDublinOrders();
           this.getMakeupStrabaneOrders();
        });
  },
 
  mounted() {
    if (localStorage.internal_orders_start_date) {
      this.start_date = localStorage.internal_orders_start_date;
    }
    else{
      this.start_date = this.getStartDate()
    }

    if (localStorage.internal_orders_end_date) {
      this.end_date = localStorage.internal_orders_end_date;
    }
    else{
      this.end_date = new Date().toISOString().slice(0,10)
    }
      
  },
  watch: {
    
    start_date: function () {
      localStorage.internal_orders_start_date = this.start_date;
      if(this.accessToken != "")
        {
        //this.internal_orders = []
        console.log("Start date changed")
        this.getInternalOrders()
        this.getMakeupDublinOrders();
        this.getMakeupStrabaneOrders();
        }
    },
    end_date: function () {
      localStorage.internal_orders_end_date = this.end_date;
      if(this.accessToken != "")
        {
        //this.internal_orders = []
        console.log("End date changed")
        this.getInternalOrders()
        this.getMakeupDublinOrders();
        this.getMakeupStrabaneOrders();
        }
    },
   
  }
}


</script>

